/**
 * Feature flag utilities backed by sessionStorage.
 * Each flag is stored in sessionStorage (e.g. "NCDPhaseTwoFlag") and read
 * without creating React or selector dependencies to avoid circular imports.
 * */

// Example: Use this pattern for future feature flags backed by sessionStorage.
const isNCDPhase2Enabled = (env) => typeof window !== 'undefined'
    && sessionStorage.getItem('NCDPhaseTwoFlag') === 'Y'
    && ['local', 'dev'].includes(env?.toLowerCase());

const isRebuildCalculatorEnabled = (serverConfig) => typeof window !== 'undefined'
    && serverConfig.get('rebuildCostCalculatorEnabled');

const isContentsCalculatorEnabled = (serverConfig) => typeof window !== 'undefined'
    && serverConfig.get('contentsCostCalculatorEnabled');

const isHealthCrossellExperimentEnabled = (serverConfig) => typeof window !== 'undefined'
    && !!serverConfig?.get('healthCrossellExperimentEnabled');

export { isNCDPhase2Enabled, isRebuildCalculatorEnabled, isContentsCalculatorEnabled, isHealthCrossellExperimentEnabled };
